import { IeLynxObject } from "../../common/models/eLynxObject";

export const keys = {
    all: ["defaults"],
    defaults: (
        groupID: number,
        eLynxObject: IeLynxObject
    ) => [
        ...keys.all,
        "defaults", {
            groupID,
            eLynxObject
        }
    ]
}